'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var l=({color:i,size:t,className:e,...o})=>jsxRuntime.jsx("div",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-spinner ${e||""}`),...o,children:jsxRuntime.jsx("div",{className:`spinner ${i} ${t}`})}),a=l;

exports.a = a;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-IJCIXIR3.js.map